import React from 'react';

const MinorParagraph: React.SFC<{ style?: React.CSSProperties }> = ({ children, style }) => {
	return <p style={{ ...{ color: 'gray', fontStyle: 'italic' }, ...style }}>{children}</p>
}

export default MinorParagraph